import { useGet } from '../../HttpClient';
import { tenantHierarchyBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

const pillarCode = "tms";
 
export function useAggregatedRule({ ouId, category }: { ouId: string; category: string }) {
  const get = useGet(true, pillarCode);
  const getAggregatedRules = async (ouId: string, category: string) =>
    get<any[]>(`${tenantHierarchyBaseUrl}/organisation-units/${ouId}/config/${category}`);

  return useQueryWithErrorHandling({
    queryKey: ['aggregated-rule', category, ouId],
    queryFn: async () => await getAggregatedRules(ouId, category),
    enabled: !!ouId && !!category,
    refetchOnMount: true,
  });
}
